module.exports = __webpack_public_path__ + "img/default_auth_image.0afa0fb5.svg";